import { darken, lighten } from 'polished';
import styled from 'styled-components';

export const SelectNewUnityToWorkContainer = styled.div`
  transition: 0.3s all;
  background-color: ${lighten(0.12, '#0f4f4f')};
  border-radius: 0.2rem;
  border-radius: 0.4rem;
  padding: 0.4rem;
  display: flex;
  align-items: center;
  height: 40px;
  cursor: pointer;
  &:hover {
    background-color: ${darken(0.05, '#0f4f4f')};
  }
  span {
    font-size: 0.85rem;
    color: ${({ theme }) => theme.COLORS.WHITE};
  }
  svg {
    fill: ${({ theme }) => theme.COLORS.WHITE};
    path {
      fill: ${({ theme }) => theme.COLORS.WHITE};
    }
    transition: 0.3s all;
    margin-right: 0.4rem;
    width: 20px;
    height: 20px;
  }
  @media (max-width: 650px) {
    display: none;
  }
`;
